<template>
  <div v-if="isVisible && !hasChildModalOpen" class="modal-overlay" @click="closeModal">
    <div class="modal-container" @click.stop>
      <div class="modal-header">
        <h2 class="modal-title">{{$t('manage_your_subscription')}}</h2>
        <button class="close-button" @click="closeModal">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.55323 6.37557L13.6243 13.4466C13.6456 13.468 13.6588 13.4988 13.6588 13.535C13.6588 13.5713 13.6456 13.6021 13.6243 13.6234C13.603 13.6447 13.5722 13.6579 13.5359 13.6579C13.4996 13.6579 13.4688 13.6447 13.4475 13.6234L6.37646 6.55235C6.35514 6.53103 6.34193 6.50023 6.34193 6.46396C6.34193 6.4277 6.35514 6.39689 6.37646 6.37557C6.39777 6.35426 6.42858 6.34105 6.46484 6.34105C6.50111 6.34105 6.53191 6.35426 6.55323 6.37557Z" fill="#282A36" stroke="#282A36"/>
            <path d="M13.6235 6.37557C13.6449 6.39689 13.6581 6.4277 13.6581 6.46396C13.6581 6.50023 13.6449 6.53103 13.6235 6.55235L6.55248 13.6234C6.53116 13.6447 6.50035 13.6579 6.46409 13.6579C6.42782 13.6579 6.39702 13.6447 6.3757 13.6234C6.35438 13.6021 6.34117 13.5713 6.34117 13.535C6.34117 13.4988 6.35438 13.468 6.3757 13.4466L13.4468 6.37557C13.4681 6.35426 13.4989 6.34105 13.5352 6.34105C13.5714 6.34105 13.6022 6.35426 13.6235 6.37557Z" fill="#282A36" stroke="#282A36"/>
          </svg>
        </button>
      </div>

      <div class="subscription-info">
        <p class="subscription-text">
          <span>{{$t('free_of_charge')}}</span> {{$t('try')}} <span>{{ package_expiry }}</span>' {{$t('coming_to_an_end')}}.
        </p>
      </div>

      <div class="modal-content">
        <div class="billing-section">
          <h3 class="section-title">{{$t('billing_information')}}</h3>

          <div class="billing-form">
            <div v-if="billingInfo.billingType === 'individual'" class="form-row">
              <div class="form-group">
                <label>{{$t('name_surname_content')}}</label>
                <span>{{ billingInfo.name || 'Bilgi bulunamadı' }}</span>
              </div>
            </div>

            <div v-if="billingInfo.billingType === 'corporate'">
              <div class="form-row">
                <div class="form-group">
                  <label>{{$t('trade_name')}}</label>
                  <span>{{ billingInfo.companyName || 'Bilgi bulunamadı' }}</span>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label>{{$t('tax_office')}}</label>
                  <span>{{ billingInfo.taxOffice || 'Bilgi bulunamadı' }}</span>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label>{{$t('tax_identification')}}</label>
                  <span>{{ billingInfo.taxNumber || 'Bilgi bulunamadı' }}</span>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>{{$t('email')}}</label>
                <span>{{ billingInfo.email || 'Bilgi bulunamadı' }}</span>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>{{$t('gsm_no')}}</label>
                <span>{{ billingInfo.phone || 'Bilgi bulunamadı' }}</span>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>{{$t('country_city')}}</label>
                <span>{{ billingInfo.location || 'Bilgi bulunamadı' }}</span>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>{{$t('postal_code')}}</label>
                <span>{{ billingInfo.postalCode || 'Bilgi bulunamadı' }}</span>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group full-width">
                <label>{{$t('address_person')}}</label>
                <span>{{ billingInfo.address || 'Bilgi bulunamadı' }}</span>
              </div>
            </div>
          </div>

          <button class="add-card-button mt-3" @click="openBillingInfoModal">
            {{$t('update_information')}}
          </button>
        </div>

        <div class="billing-section">
          <h3 class="section-title">{{$t('payment_information')}}</h3>

          <div v-if="loading" style="text-align: center; padding: 20px; color: #5d6370; font-size: 12px;">
          </div>

          <div v-if="!loading && paymentMethods.length === 0" style="text-align: center; padding: 20px; color: #5d6370; font-size: 12px;">
            {{$t('no_cards_registered_yet')}}.
          </div>

          <div class="payment-methods" v-if="!loading && paymentMethods.length > 0">
            <div
                v-for="card in paymentMethods"
                :key="card.cardId"
                class="payment-method"
            >
              <div class="card-info">
                <div :class="['card-icon', card.cardBrand.toLowerCase()]">
                  <img :src="'/card/'+card.cardBrand+'.svg'" alt="">
                </div>

                <div class="card-details">
                  <span class="card-brand">{{ getCardBrandName(card.cardBrand) }}</span>
                  <div class="card-row">
                    <span class="card-number">{{ card.maskedCardNumber }}</span>
                    <span class="card-expiry">{{ String(card.expiryMonth).padStart(2, '0') }}/{{ card.expiryYear }}</span>
                  </div>
                </div>
              </div>

              <div class="actions-wrapper">
                <button
                    class="star-button"
                    @click="makePrimary(card.cardId)"
                    :disabled="makingPrimaryCardId === card.cardId || card.isPrimary"
                    :title="card.isPrimary ? 'Birincil kart' : 'Birincil kart yap'"
                >
                  <div v-if="makingPrimaryCardId === card.cardId" class="spinner-small"></div>
                  <template v-else>
                    <svg v-if="!card.isPrimary" width="16" height="16" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.7299 2.50989L14.4899 6.02989C14.7299 6.51989 15.3699 6.98989 15.9099 7.07989L19.0999 7.60989C21.1399 7.94989 21.6199 9.42989 20.1499 10.8899L17.6699 13.3699C17.2499 13.7899 17.0199 14.5999 17.1499 15.1799L17.8599 18.2499C18.4199 20.6799 17.1299 21.6199 14.9799 20.3499L11.9899 18.5799C11.4499 18.2599 10.5599 18.2599 10.0099 18.5799L7.01991 20.3499C4.87991 21.6199 3.57991 20.6699 4.13991 18.2499L4.84991 15.1799C4.97991 14.5999 4.74991 13.7899 4.32991 13.3699L1.84991 10.8899C0.389909 9.42989 0.859909 7.94989 2.89991 7.60989L6.08991 7.07989C6.61991 6.98989 7.25991 6.51989 7.49991 6.02989L9.25991 2.50989C10.2199 0.599893 11.7799 0.599893 12.7299 2.50989Z" stroke="#FFB800" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                    <svg v-if="card.isPrimary" width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.7299 1.50989L13.4899 5.02989C13.7299 5.51989 14.3699 5.98989 14.9099 6.07989L18.0999 6.60989C20.1399 6.94989 20.6199 8.42989 19.1499 9.88989L16.6699 12.3699C16.2499 12.7899 16.0199 13.5999 16.1499 14.1799L16.8599 17.2499C17.4199 19.6799 16.1299 20.6199 13.9799 19.3499L10.9899 17.5799C10.4499 17.2599 9.55991 17.2599 9.00991 17.5799L6.01991 19.3499C3.87991 20.6199 2.57991 19.6699 3.13991 17.2499L3.84991 14.1799C3.97991 13.5999 3.74991 12.7899 3.32991 12.3699L0.849909 9.88989C-0.610091 8.42989 -0.140091 6.94989 1.89991 6.60989L5.08991 6.07989C5.61991 5.98989 6.25991 5.51989 6.49991 5.02989L8.25991 1.50989C9.21991 -0.400107 10.7799 -0.400107 11.7299 1.50989Z" fill="#FFB800"/>
                    </svg>
                  </template>
                </button>

                <button
                    class="delete-button"
                    @click="deleteCard(card.cardId)"
                    :disabled="deletingCardId === card.cardId"
                >
                  <div v-if="deletingCardId === card.cardId" class="spinner"></div>
                  <svg v-else width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.0471 3.48732C12.9738 3.38065 11.9004 3.30065 10.8204 3.24065V3.23398L10.6738 2.36732C10.5738 1.75398 10.4271 0.833984 8.8671 0.833984H7.12043C5.5671 0.833984 5.42043 1.71398 5.31376 2.36065L5.17376 3.21398C4.55376 3.25398 3.93376 3.29398 3.31376 3.35398L1.95376 3.48732C1.67376 3.51398 1.47376 3.76065 1.50043 4.03398C1.5271 4.30732 1.7671 4.50732 2.0471 4.48065L3.4071 4.34732C6.90043 4.00065 10.4204 4.13398 13.9538 4.48732C13.9738 4.48732 13.9871 4.48732 14.0071 4.48732C14.2604 4.48732 14.4804 4.29398 14.5071 4.03398C14.5271 3.76065 14.3271 3.51398 14.0471 3.48732Z" fill="#667085"/>
                    <path opacity="0.3991" d="M12.8192 5.42602C12.6592 5.25935 12.4392 5.16602 12.2125 5.16602H3.78585C3.55918 5.16602 3.33252 5.25935 3.17918 5.42602C3.02585 5.59268 2.93918 5.81935 2.95252 6.05268L3.36585 12.8927C3.43918 13.906 3.53252 15.1727 5.85918 15.1727H10.1392C12.4658 15.1727 12.5592 13.9127 12.6325 12.8927L13.0458 6.05935C13.0592 5.81935 12.9725 5.59268 12.8192 5.42602Z" fill="#667085"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.38672 11.334C6.38672 11.0578 6.61058 10.834 6.88672 10.834H9.10672C9.38286 10.834 9.60672 11.0578 9.60672 11.334C9.60672 11.6101 9.38286 11.834 9.10672 11.834H6.88672C6.61058 11.834 6.38672 11.6101 6.38672 11.334Z" fill="#667085"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.83398 8.66602C5.83398 8.38987 6.05784 8.16602 6.33398 8.16602H9.66732C9.94346 8.16602 10.1673 8.38987 10.1673 8.66602C10.1673 8.94216 9.94346 9.16602 9.66732 9.16602H6.33398C6.05784 9.16602 5.83398 8.94216 5.83398 8.66602Z" fill="#667085"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <button class="add-card-button" @click="openAddCardModal">
            {{$t('add_new_card')}}
          </button>
        </div>
      </div>
    </div>
  </div>

  <PricingInformationModal
      :is-visible="isPricingInfoModalOpen"
      :billing-info="billingInfo"
      :mode="modalMode"
      @close="closeBillingInfoModal"
      @save="onBillingInfoSave"
  />

  <PricingAddNewCardModal
      :is-visible="isAddCardModalOpen"
      :skip3DSecure="false"
      @close="closeAddCardModal"
      @save="onCardSave"
  />
</template>

<script>
import PricingInformationModal from '@/components/modals/PricingInformation.vue';
import PricingAddNewCardModal from '@/components/modals/PricingAddNewCardModal.vue';
import pricingService from '@/service/pricingService';
import commonService from '@/service/commonService';
import {handleErrorResponse} from "@/utils/utils";

export default {
  name: 'PricingManagementModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },

  components: {
    PricingInformationModal,
    PricingAddNewCardModal,
  },

  data() {
    return {
      package_expiry:'',
      billingInfo: {
        name: '',
        email: '',
        phone: '',
        location: '',
        postalCode: '',
        address: '',
        companyName: '',
        billingType: 'individual'
      },
      isPricingInfoModalOpen: false,
      isAddCardModalOpen: false,
      paymentMethods: [],
      loading: false,
      billingLoading: false,
      modalMode: 'update',
      hasBillingData: false,
      deletingCardId: null,
      makingPrimaryCardId: null
    }
  },

  watch: {
    isVisible: {
      immediate: true,
      async handler(newValue) {
        if (newValue) {
          await this.loadData();
        }
      }
    }
  },

  computed: {
    hasChildModalOpen() {
      return this.isPricingInfoModalOpen || this.isAddCardModalOpen
    }
  },

  async created() {
    await this.loadData();
  },

  methods: {
    async loadData() {
      await Promise.allSettled([
        this.loadBillingInfo(),
        this.loadPaymentMethods(),
      ]);
    },

    async loadBillingInfo() {
      try {
        this.billingLoading = true;
        const response = await pricingService.getBillingInfo();

        if (response?.data?.responseType === 'success') {
          if (response.data.packageStatus) {
            this.package_expiry = response.data.packageStatus.endDateTime || '';
          }

          const billingData = response.data?.data?.data || [];
          this.modalMode = pricingService.getBillingModalMode(billingData);
          this.hasBillingData = !pricingService.isBillingDataEmpty(billingData);

          if (billingData.length > 0) {
            const activeBilling = billingData.find(item => item.isActive && item.isDefault) || billingData[0];

            if (activeBilling) {

              this.billingInfo = {
                billingId: activeBilling.billingId,
                name: `${activeBilling.firstName || ''} ${activeBilling.lastName || ''}`.trim(),
                email: activeBilling.email || 'Bilgi bulunamadı',
                phone: activeBilling.phone || 'Bilgi bulunamadı',
                location: this.formatLocation(activeBilling.countryName, activeBilling.cityName),
                postalCode: activeBilling.postalCode || 'Bilgi bulunamadı',
                address: activeBilling.addressLine || 'Bilgi bulunamadı',
                companyName: activeBilling.companyName || '',
                billingType: activeBilling.billingType || 'individual',
                firstName: activeBilling.firstName || '',
                lastName: activeBilling.lastName || '',
                country: activeBilling.country || '',
                city: activeBilling.city || '',
                countryName: activeBilling.countryName || '',
                cityName: activeBilling.cityName || '',
                addressLine: activeBilling.addressLine || '',
                taxNumber: activeBilling.taxNumber || '',
                taxOffice: activeBilling.taxOffice || '',
                district: activeBilling.district || '',
                isDefault: activeBilling.isDefault || true,
                isActive: activeBilling.isActive || true
              };

              this.modalMode = 'update';
              this.hasBillingData = true;
            }
          } else {
            this.modalMode = 'add';
            this.hasBillingData = false;
            this.billingInfo = {
              billingId: null,
              name: '',
              email: '',
              phone: '',
              location: '',
              postalCode: '',
              address: '',
              companyName: '',
              billingType: 'individual',
              firstName: '',
              lastName: '',
              country: '',
              city: '',
              countryName: '',
              cityName: '',
              addressLine: '',
              taxNumber: '',
              taxOffice: '',
              district: '',
              isDefault: true,
              isActive: true
            };
          }
        }
      } catch (error) {
        this.modalMode = 'add';
        this.hasBillingData = false;
        this.package_expiry = '';

        this.billingInfo = {
          billingId: null,
          name: '',
          email: '',
          phone: '',
          location: '',
          postalCode: '',
          address: '',
          companyName: '',
          billingType: 'individual'
        };
      } finally {
        this.billingLoading = false;
      }
    },

    async loadPaymentMethods() {
      try {
        this.loading = true;
        const response = await pricingService.getPaymentMethods();
        this.paymentMethods = response?.data?.data?.data || [];
      } catch (error) {
        this.paymentMethods = [];
      } finally {
        this.loading = false;
      }
    },

    formatLocation(country, city) {
      const countryValue = country || '';
      const cityValue = city || '';

      if (!countryValue && !cityValue) return 'Bilgi bulunamadı';
      if (!countryValue) return cityValue;
      if (!cityValue) return countryValue;
      return `${countryValue}, ${cityValue}`;
    },

    closeModal() {
      this.$emit('close');
    },

    async makePrimary(cardId) {
      if (!cardId) {
        return;
      }

      const card = this.paymentMethods?.find(c => c?.cardId === cardId);
      if (card?.isPrimary) {
        return;
      }

      try {
        this.makingPrimaryCardId = cardId;

        const response = await pricingService.makePrimaryCard(cardId);

        if (response?.data?.responseType === 'success') {
          this.paymentMethods = this.paymentMethods.map(card => ({
            ...card,
            isPrimary: card?.cardId === cardId
          }));

          this.$emit('card-primary-changed', {
            cardId,
            cardData: response?.data?.data || null
          });

          this.$snackbar?.success?.('Kart başarıyla birincil kart olarak ayarlandı');

        } else {
          throw new Error('Primary yapma işlemi başarısız');
        }

      } catch (error) {
        this.$snackbar?.error?.('Kart birincil yapılırken bir hata oluştu. Lütfen tekrar deneyin.');
      } finally {
        this.makingPrimaryCardId = null;
      }
    },

    async deleteCard(cardId) {
      if (!cardId) {
        return;
      }

      this.deletingCardId = cardId;

      pricingService.deletePaymentMethod(cardId).then(response=> {
        if (response?.data?.responseType === 'success') {
          this.paymentMethods = this.paymentMethods?.filter(card => card?.cardId !== cardId) || [];

          this.$emit('card-deleted', cardId);

          this.$snackbar?.success?.('Kart başarıyla silindi');

        } else {
          throw new Error('Silme işlemi başarısız');
        }
      }).catch(error => {
        handleErrorResponse(error, this.$snackbar);
      }).finally(() => {
        this.deletingCardId = null;
      });
    },

    openBillingInfoModal() {
      if (this.modalMode === 'add' || !this.hasBillingData) {
        this.isPricingInfoModalOpen = true;
      } else {
        this.isPricingInfoModalOpen = true;
      }
    },

    closeBillingInfoModal() {
      this.isPricingInfoModalOpen = false;
    },

    async onBillingInfoSave(updatedBillingData) {

      if (updatedBillingData) {
        this.updateBillingInfoFromResponse(updatedBillingData);

        this.modalMode = 'update';
        this.hasBillingData = true;
      }

      this.closeBillingInfoModal();
      this.$emit('billing-updated', updatedBillingData);

      setTimeout(async () => {
        try {
          await this.loadBillingInfo();
        } catch (error) {
        }
      }, 500);
    },

    updateBillingInfoFromResponse(responseData) {
      if (!responseData) {
        return;
      }

      this.billingInfo = {
        billingId: responseData.billingId || this.billingInfo.billingId || null,
        name: `${responseData.firstName || ''} ${responseData.lastName || ''}`.trim(),
        email: responseData.email || 'Bilgi bulunamadı',
        phone: responseData.phone || 'Bilgi bulunamadı',
        location: this.formatLocation(responseData.countryName || responseData.country, responseData.cityName || responseData.city),
        postalCode: responseData.postalCode || 'Bilgi bulunamadı',
        address: responseData.addressLine || 'Bilgi bulunamadı',
        companyName: responseData.companyName || '',
        billingType: responseData.billingType || 'individual',
        firstName: responseData.firstName || '',
        lastName: responseData.lastName || '',
        country: responseData.country || '',
        city: responseData.city || '',
        countryName: responseData.countryName || '',
        cityName: responseData.cityName || '',
        addressLine: responseData.addressLine || '',
        taxNumber: responseData.taxNumber || '',
        taxOffice: responseData.taxOffice || '',
        district: responseData.district || '',
        isDefault: responseData.isDefault !== undefined ? responseData.isDefault : true,
        isActive: responseData.isActive !== undefined ? responseData.isActive : true
      };
    },

    openAddCardModal() {
      this.isAddCardModalOpen = true;
    },

    closeAddCardModal() {
      this.isAddCardModalOpen = false;
    },

    async onCardSave(cardData) {
      try {

        if (cardData) {
          this.paymentMethods = [...this.paymentMethods, cardData];
        } else {
        }

        setTimeout(async () => {
          try {
            await this.loadPaymentMethods();
          } catch (error) {
          }
        }, 500);

        this.$emit('card-added', cardData);
        this.closeAddCardModal();

      } catch (error) {
        await this.loadPaymentMethods();
      }
    },
    getCardBrandName(brandCode) {
      const brandNames = {
        'visa': 'Visa',
        'mastercard': 'Mastercard',
        'amex': 'American Express',
        'jcb': 'JCB',
        'discover': 'Discover',
        'diners': 'Diners Club',
        'unionpay': 'Union Pay',
        'maestro': 'Maestro',
        'mir': 'Mir',
        'troy': 'Troy',
        'elo': 'Elo',
        'hipercard': 'Hipercard'
      }

      return brandNames[brandCode?.toLowerCase()] || brandCode || 'Credit Card'
    },

  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-container {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 800px;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px 0;
  border-bottom: none;
}

.modal-title {
  font-size: 18px;
  color: #1a1a1a;
  margin: 0;
  font-family: 'euclid_semi_bold' , sans-serif;
}

.close-button {
  position: absolute;
  top: 24px;
  right: 24px;
  background: #f5f5f5;
  border: none;
  cursor: pointer;
  color: #666666;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  height: 36px;
  width: 36px;
}

.subscription-info {
  padding: 0px 32px;
  display: flex;
  flex-direction: row;
}

.subscription-info p{
  color: #475467;
  font-size: 12px;
}

.subscription-info span{
  color: #0d1115;
  font-size: 12px;
  font-family: 'euclid_medium' , sans-serif;
}

.subscription-text {
  color: #666;
  margin: 0;
  font-size: 14px;
}

.modal-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  padding: 24px 32px 32px;
  width: 100% !important;
}

.section-title {
  font-size: 16px;
  color: #1a1a1a;
  margin: 0 0 24px 0;
  font-family: 'euclid_semi_bold' , sans-serif;
}

.billing-section{
  display: flex;
  align-self: start;
  flex-direction: column;
  background-color: #F5F5F5;
  padding: 15px;
  border-radius: 12px;
}

.billing-form {
  display: flex;
  flex-direction: column;
}

.form-row {
  display: flex;
  gap: 16px;
  min-height: 40px;
  margin-bottom: 10px;
}

.form-group {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  flex: 100%;
}

.form-group label {
  font-size: 12px;
  color: #515766;
  font-family: 'euclid_regular' , sans-serif;
}

.form-group span {
  font-size: 12px;
  color: #0a0d14;
  margin-bottom: 6px;
  font-family: 'euclid_medium' , sans-serif;
}

.payment-methods {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

.payment-method {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.card-icon {
  width: 32px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.card-brand {
  font-size: 14px;
  color: #000000;
  font-family: 'euclid_medium' , sans-serif;
}

.card-row{
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.card-number {
  font-size: 12px;
  color: #6b7280;
  font-family: 'euclid_medium' , sans-serif;
}

.card-expiry {
  font-size: 12px;
  color: #6b7280;
  font-family: 'euclid_medium' , sans-serif;
}

.actions-wrapper{
  display: flex;
  flex-direction: row;
}

.star-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.star-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.spinner-small {
  width: 12px;
  height: 12px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #FFB800;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.delete-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #ef4444;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.add-card-button {
  display: flex;
  height: 32px;
  width: 150px;
  background: #1f2937;
  color: white;
  border: none;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  font-size: 14px;
  font-family: 'euclid_medium' , sans-serif;
}

.add-card-button:hover {
  background: #111827;
}

@media (max-width: 768px) {
  .modal-container {
    width: 95%;
    margin: 20px;
  }

  .modal-content {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .modal-header {
    padding: 20px 24px 0;
  }

  .modal-content {
    padding: 20px 24px 24px;
  }

  .form-row {
    flex-direction: column;
    gap: 12px;
  }
}
</style>
